import * as actionTypes from '../actions/actionTypes'
export const authenticateReducer = (state = {}, action) => {
    switch (action.type) {
      case actionTypes.AUTHENTICATE_USER:
        return action.authInfo;
      case 'UPDATE_TOKENS':
        return {
          ...state,
          access_token: action.accessToken,
          refresh_token: action.refreshToken
        };
      default:
        return state;
    }
  };